var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"card-header d-flex justify-content-between align-items-center"},[_c('h4',{staticClass:"card-header-title mb-0 font-weight-bold"},[_vm._v("IDP Attendance")])])
}]

export { render, staticRenderFns }